import { getCheckUserUrl } from '../config';

/**
 * Look up a vpn-users record by email via the Pages Function.
 * 404 → not found. Other failures are returned as { error: true } so checkout
 * can continue if the lookup is unavailable.
 */
export async function checkUserByEmail(email) {
  const trimmed = (email || '').trim();
  if (!trimmed) {
    return { found: false };
  }

  try {
    const response = await fetch(
      `${getCheckUserUrl()}?email=${encodeURIComponent(trimmed)}`,
      { method: 'GET', headers: { Accept: 'application/json' } }
    );

    if (response.status === 404) {
      return { found: false };
    }

    const contentType = response.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      return { found: false, error: true, status: response.status };
    }

    const data = await response.json().catch(() => null);
    if (!response.ok) {
      return { found: false, error: true, status: response.status, data };
    }

    if (!data || !data.email) {
      return { found: false };
    }

    return { found: true, user: data };
  } catch (err) {
    return { found: false, error: true, message: err?.message || String(err) };
  }
}

export function hasActiveSubscription(user) {
  const ttl = user?.ttl;
  if (ttl == null || ttl === '') {
    return false;
  }
  const ttlEpoch = Number(ttl);
  if (!Number.isFinite(ttlEpoch)) {
    return false;
  }
  return ttlEpoch >= Math.floor(Date.now() / 1000);
}
